import { MIN_LIMIT_ORDER_SHARES, MIN_MARKET_ORDER_USDC } from '@/constants/trade-order-limits';

/**
 * 校验下单最小金额/份额
 * @returns {{ ok: true } | { ok: false, code: 'belowMinMarketAmount' | 'belowMinLimitShares' }}
 */
export function validateTradeOrderMinLimits(order) {
  const isMarket = order?.orderType === 'market';
  const isSell =
    String(order?.side ?? '')
      .trim()
      .toLowerCase() === 'sell';

  // 卖出不按 $1 或 5 份门槛拦截（限价/市价均可按持仓份数卖）
  if (isSell) {
    return { ok: true };
  }

  if (isMarket) {
    const amount = Number(order?.amountDollars ?? 0);
    if (!Number.isFinite(amount) || amount < MIN_MARKET_ORDER_USDC) {
      return { ok: false, code: 'belowMinMarketAmount' };
    }
    return { ok: true };
  }

  const shares = Number(order?.shares ?? 0);
  if (!Number.isFinite(shares) || shares < MIN_LIMIT_ORDER_SHARES) {
    return { ok: false, code: 'belowMinLimitShares' };
  }
  return { ok: true };
}
